// web/src/components/SubDeck.tsx
// The top-of-cover teaser strip — "PLUS · 3 GOALS · CAPTAIN · 9/10 RATING".
// Small-caps sans, separated by middots. Pair with `subDeckFor(match)` from
// utils/cover-line.ts.

import type { CSSProperties } from 'react';

export interface SubDeckProps {
  items: string[];
  /** Optional prefix word, default "PLUS". Pass empty string to omit. */
  prefix?: string;
  onDark?: boolean;
  style?: CSSProperties;
}

export function SubDeck({ items, prefix = 'PLUS', onDark = false, style }: SubDeckProps) {
  if (items.length === 0) return null;
  const all = prefix ? [prefix, ...items] : items;
  return (
    <div
      style={{
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--small)',
        fontWeight: 600,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: onDark ? 'var(--gold-light)' : 'var(--green)',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'baseline',
        gap: 'var(--space-sm)',
        ...style,
      }}
    >
      {all.map((item, i) => (
        <span key={`${i}-${item}`} style={{ display: 'inline-flex', alignItems: 'baseline', gap: 'var(--space-sm)' }}>
          {i > 0 ? <span aria-hidden style={{ opacity: 0.6 }}>·</span> : null}
          <span>{item}</span>
        </span>
      ))}
    </div>
  );
}
